const Colors = {
  whiteSmoke: "rgb(221, 221, 221)",
  lightPrimary: "#06bbd3",
  primary: "#0180ff",
  lightDanger: "rgb(233, 81, 78)",
  danger: "#ff0101",
  lightSuccess: "rgb(78, 196, 84)",
  success: "#22ce29",
  lightWarning: "rgb(255, 208, 0)",
  warning: "#fcc603",
  light: "rgb(255, 255, 255)",
  dark: "rgb(0, 0, 0)",
  offMode: "#3b3b3b",
  royalBlue: "#1e5279",
  secondary: "#9aa0b0",
};
export default Colors;
